<template>
  <MTableCell class="m-table-cell-metric-performance-container">
    <div
      v-if="value !== null && value !== undefined && value !== '-'"
      class="m-table-cell-metric-performance"
      :class="classList"
      :title="value"
    >
      <span>{{ value }}</span>
    </div>

    <div
      v-else
      class="m-table-cell-metric-performance"
      title="—"
    >
      <span>—</span>
    </div>
  </MTableCell>
</template>

<script>
  import {mTableCells} from '@marilyn/marilyn-ui';

  export default {
    name: 'MTableCellMetricPerformance',
    components: {
      MTableCell: mTableCells.MTableCell
    },
    props: {
      itemKey: {
        type: String,
        default: ''
      },
      tableRow: {
        type: Object,
        default: Object
      },
      isPositiveGrowth: {
        type: Boolean,
        default: true
      },
      withSummaryRow: {
        type: Boolean,
        default: false
      },
      index: {
        type: [Number, null],
        default: null
      }
    },
    computed: {
      classList () {
        return {
          __positive: this.isPositive,
          __negative: !this.isPositive
        };
      },
      metric () {
        return this.tableRow.metrics[this.itemKey];
      },
      value () {
        return this.metric.value;
      },
      isZero () {
        return this.metric.isZero;
      },
      isPositive () {
        if (this.isZero) {
          return false;
        }

        const isPositiveValue = this.metric.isPositive;

        if (this.isPositiveGrowth) {
          return isPositiveValue;
        }

        return !isPositiveValue;
      },
      isSummaryCell () {
        return this.withSummaryRow && this.index === 0;
      }
    }
  };
</script>

<style>
  .m-table-cell-container:not(.m-table-cell-container_is-last) .m-table-cell-metric-performance-container {
    padding-right: 0 !important;
  }

  .m-table-cell-container_is-last .m-table-cell-metric-performance-container {
    padding-right: 8px !important;
  }

  .m-table-cell-metric-performance {
    width: 100%;
    padding: 0 4px 0 0;
    text-align: right;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    span {
      font-weight: inherit;
    }

    &.__positive {
      color: var(--color-status-positive);
    }

    &.__negative {
      color: var(--color-status-neutral);
    }
  }
</style>
